<template>
  <div class="setting-online-satisfaction">
    <div class="module-item-style">
      <div class="module-item-title satisfaction-title">
        <div>
          客服满意度调查
        </div>
        <div class="satisfaction-switch-btn">
          <el-switch
              v-model="evaluate_auto"
              @change="saveChange('evaluate_auto',evaluate_auto)"
              active-color="#68B974">
          </el-switch>
        </div>
      </div>
      <div class="satisfaction-tips">
        开启后，访客端结束会话时将展示满意度调查入口，访客可以针对本次对话为客服进行评价
      </div>
      <div class="satisfaction-content" v-if="showContentBox">
        <el-input
            class="input-textarea"
            type="textarea"
            resize="none"
            rows="4"
            maxlength="250"
            show-word-limit
            @blur="saveChange('evaluate_content',evaluate_content)"
            placeholder="请输入内容..."
            v-model="evaluate_content">
        </el-input>
        <!-- <div class="satisfaction-tips">
          会话结束后，系统会向访客发出一条结束提示
        </div> -->
      </div>
    </div>
	<div class="module-item-style">
		<div class="module-item-title">微信公众号评价邀请语自定义设置</div>
		<div class="module-item-tips">微信公众号评价邀请语可以自定义设置，自定义的评价邀请语会显示在微信公众号对话页面</div>
		<div class="wx-evaContent-setting">
			<el-input
			type="textarea"
			resize="none"
			rows="4"
			maxlength="250"
			show-word-limit
			@blur="saveChange('invite_evaluation_content',wxEvaluateContent)" 
			v-model="wxEvaluateContent" 
			placeholder="请输入微信公众号评价邀请语"></el-input>
		</div>
	</div>
	<div class="module-item-style">
		<div class="module-item-title">自定义评价标签</div>
		<div class="module-item-tips">评价标签可自定义，自定义的标签会显示在访客端会话评价页面。</div>
		<!-- <div class="tag-add-btn">
		    <div class="wl-btn"><i class="el-icon-plus"></i>添加标签</div>
		</div> -->
		<div class="table-box">
		    <el-table
		            :data="tableData"
		            stripe
		            :header-cell-style="{background:'#f2f2f2'}"
		            style="border: 1px solid #ebeef5;">
		        <el-table-column label="评价等级" width="300px" class="level">
		          <template slot-scope="scope">
					  <span v-if="scope.row.level==5">非常满意 </span>
					  <span v-if="scope.row.level==4">比较满意 </span>
					  <span v-if="scope.row.level==3">一般满意 </span>
					  <span v-if="scope.row.level==2">比较不满意 </span>
					  <span v-if="scope.row.level==1">非常不满意 </span>
					  <el-rate disabled disabled-void-color="#ddd"
					   score-template="{value}"
					   v-model="scope.row.level"></el-rate>
		          </template>
		        </el-table-column>
				<el-table-column label="评价标签">
				  <template slot-scope="scope">
					<div class="tag-list">
						<div v-if="scope.row.tagList.length == 0">--</div>
						<div v-else v-for="(tag,index) in scope.row.tagList" :key="index">
							<el-tag closable @close="handleButton('delMethods', tag.id,scope.row.level)" type="info">{{tag.evaluateTagName}}</el-tag>
						</div>
					</div>
				    
				  </template>
				</el-table-column>
		        <el-table-column label="操作" width="120px" align="center">
		            <template slot-scope="scope">
						<button class="tb-btn tb-btn-edit" @click="handleButton('addMethods', '',scope.row.level)">添加</button>
		            </template>
		        </el-table-column>
		    </el-table>
		</div>
	</div>
	<el-dialog
	        :title="tagDialogTitle"
	        width="450px"
	        class="tag-dialog"
	        :visible.sync="dialogFormVisible">
	    <div class="tag-content-container">
			<div class="tag-input-box">
			    <div class="tag-input-label"><span>*</span>评价等级：</div>
			    <div>
			        <el-rate disabled disabled-void-color="#ddd"
			         score-template="{value}"
			         v-model="tagForm.grade"></el-rate>
			    </div>
			</div>
	        <div class="tag-input-box">
	            <div class="tag-input-label"><span>*</span>标签名称：</div>
	            <div>
	                <el-input v-model="tagForm.tagName" maxlength="10" show-word-limit  placeholder="请输入内容"></el-input>
	            </div>
	        </div>
	    </div>
	    <div slot="footer" class="dialog-footer">
	        <el-button @click="dialogFormVisible = false">取 消</el-button>
	        <el-button type="primary" @click="submitData">确 定</el-button>
	    </div>
	</el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'setting-online-satisfaction',
    data() {
      return {
        evaluate_auto:false,
        evaluate_content:'',
        showContentBox: false,
		wxEvaluateContent: '',
		tagDialogTitle: '添加标签',
		dialogFormVisible: false,
		dialogType:'add',		
		tagForm: {
		    grade: '', // 评价等级
		    tagName: ''
		},
		tableHandler: [
		    // {label: "添加", type: 'add', methods: 'addMethods'},
		    // {label: "删除", type: 'del', methods: 'delMethods'},
		],
		tableData: [],
      }
    },
    created() {
      this.getSatisfactionData()
	  this.getTagData()
    },
    mounted() {

    },
    methods: {
      getSatisfactionData(){
        this.$http.getSatisfactionConfigAPI().then( res => {
		  console.log(res)
          if(res.status == 1){
            let data = res.data
            if(data.evaluate_auto == 1){
              this.evaluate_auto = true
              this.showContentBox = true
            }else {
              this.evaluate_auto = false
              this.showContentBox = false
            }
			this.wxEvaluateContent = data.invite_evaluation_content
            this.evaluate_content = data.evaluate_content
          }
        })
      },
      saveChange(name,value){
        let postValue ;
		if(value == 'true' || value == true){
			postValue = 1
		}else if (value == 'false' || value == false) {
			postValue = 0
		}else {
			postValue = value
		}
        this.$http.saveConfigAPI({
          name,
          value:postValue
        }).then( res => {
          if(res.status == 1){
            this.$message({
              message: res.msg,
              type: 'success',
            })
            this.getSatisfactionData()
          }else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
      },
	  /**
	   * Author：wuzhiying
	   * Creation Time：2020-04-14 10:43
	   */
	  handleButton(methods, evaluateTagId,level) {
	      if (methods == "delMethods") {
	          this.$confirm('将要进行删除操作, 是否继续?', '提示', {
	              confirmButtonText: '确定',
	              cancelButtonText: '取消',
	              type: 'warning'
	          }).then(() => {
	              this.$http.delEvaluateTagAPI({
	                  'evaluateTagId': evaluateTagId
	              }).then(res => {
	                  if (res.status == 1) {
	                      this.getTagData()
	                      this.$message({
	                          message: res.msg,
	                          type: 'success',
	                      })
	                  } else {
	                      this.$message({
	                          message: res.msg,
	                          type: 'error',
	                      })
	                  }
	              })
	          }).catch(() => {
	  
	          });
	      } else if(methods == "addMethods"){
	          this.addTag(level)
	      }
	  
	  },
	  getTagData() {
	      this.$http.getEvaluateTagListAPI({}).then(res => {
	          if (res.status == 1) {
				  console.log(res)
	              this.tableData = res.data.reverse()
	          }
	      })
	  },
	  addTag(level) {
	      this.dialogType = 'add'
	      this.tagForm = {
	          grade: level,
	          tagName: ''
	      }
	      this.tagDialogTitle = '添加标签'
	      this.dialogFormVisible = true
	  
	  },
	  submitData() {
	      if (this.$utils.u_isEmpty(this.tagForm.tagName)) {
	          this.$message({
	              message: '标签名不能为空',
	              type: 'error',
	          })
	          return false
	  
	      }
	      if(this.dialogType == 'add'){
	          this.$http.addEvaluateTagAPI(this.tagForm).then(res => {
	              if (res.status == 1) {
	                  this.getTagData()
	                  this.dialogFormVisible = false
	                  this.$message({
	                      message: res.msg,
	                      type: 'success',
	                  })
	              } else {
	                  this.$message({
	                      message: res.msg,
	                      type: 'error',
	                  })
	              }
	          })
	      }
		  
	  },
    }
  }
</script>

<style lang="scss">
.setting-online-satisfaction{
  .satisfaction-title {
    display: flex;

    .satisfaction-switch-btn {
      margin-left: auto;
    }
  }

  .satisfaction-tips {
    color: #999;
    font-size: 12px;
    padding: 12px 0 15px 0;
  }

  .satisfaction-content {
    .input-textarea {
      width: 600px;
    }
  }
  
  .tag-add-btn {
      padding: 10px 0;
  
      i {
          font-weight: bold;
          margin-right: 3px;
      }
  }
  .tag-list{
	  display: flex;
	  flex-wrap: wrap;
	  >div{
		position: relative;
		padding: 10px 10px 0 0;
	  }
  }
  .tag-dialog {
	  .tag-input-box {
	      display: flex;
	      align-items: center;
	  
	      .tag-input-label {
	          font-size: 12px;
	          color: #333;
	  
	          span {
	              color: #FF4E00;
	              padding-right: 5px;
	              line-height: 40px;
	          }
	      }
	  }
  }
  .wx-evaContent-setting{
  	.el-textarea,.el-textarea__inner{
  		width: 600px;
  	}
  }
}
</style>
